var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrakesStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97559 8.62602C4.97559 10.2828 6.31902 11.6259 7.9749 11.6259C9.63186 11.6259 10.9756 10.2828 10.9756 8.62602C10.9756 6.9692 9.63186 5.62585 7.9749 5.62585C6.31902 5.62585 4.97559 6.9692 4.97559 8.62602Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23316 7.7597L1.03711 6.46096L1.25311 5.77535C1.86633 4.99778 3.33108 5.27977 3.48111 6.19178L4.76697 6.44263C4.67667 6.5663 4.5923 6.6958 4.51909 6.83228C4.36941 7.13435 4.27619 7.44658 4.23316 7.7597Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0566 6.52565L12.3816 6.21544C12.4909 5.31827 13.9586 4.97459 14.5944 5.75449L14.8236 6.42758L11.5504 7.89132C11.5198 7.60265 11.4496 7.31574 11.3327 7.03811C11.2572 6.85769 11.1627 6.68774 11.0566 6.52565Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrakesStatus);
export default __webpack_public_path__ + "static/media/Brakes_status.f2a7a6ea.svg";
export { ForwardRef as ReactComponent };